import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../common/utils/utils';
import Money from "../../../common/utils/money";
import { constants } from '../../../common/constants/constants';
import manager from '../../../images/newDesign/manager.svg';
import hammer from '../../../images/newDesign/hammer.svg';
import { InfoCardStyled } from './TenantList.styled';

const FilterUtils = BllinkUtils.Filter;

const TenantCard = ({ apt, selectedApt, onClick, num, filter, csvCallback }) => {
    const { t } = useTranslation();
    const ltr = useSelector(state => state.common.ltrEnabled);

    const [selected, setSelected] = useState(false);
    const [show, setShow] = useState(true);
    const [renter, setRenter] = useState();
    const [owner, setOwner] = useState();
    const [renderCsv, setRenderCsv] = useState(false);

    useEffect(() => {
        let tenantValues = [];
        apt?.tenants?.map(({ tenant, details }) => {
            const { isActive, isPrimary, tenantType } = tenant;
            const { name, phone, email } = details;
            if (isActive && isPrimary) {
                tenantValues.push(name);
                tenantValues.push(phone);
                tenantValues.push(email);

                if (tenantType === 'renter') {
                    setRenter({
                        name,
                        phone,
                        email 
                    })
                } else if (tenantType === 'owner') {
                    setOwner({
                        name,
                        phone,
                        email 
                    })
                }
            } else if (isActive) {
                tenantValues.push(name);
                tenantValues.push(phone);
                tenantValues.push(email);
            }
            return tenantValues
        });
        setRenderCsv(true);

        const showItem = FilterUtils.filterItems([apt?.apartmentNum, ...tenantValues], filter);
        setShow(showItem);
    }, [filter]);

    useEffect(() => {
        if (selectedApt?.apartmentNum === apt?.apartmentNum) setSelected(true)
        else setSelected(false)
    }, [selectedApt]);

    useEffect(() => renderCsv && csvCallback({
        apartmentNum: apt.apartmentNum,
        OwnerName: owner ? owner.name : '',
        OwnerPhone: owner ? owner.phone : '',
        OwnerEmail: owner ? owner.email : '',
        RenterName: renter ? renter.name : '',
        RenterPhone: renter ? renter.phone : '',
        RenterEmail: renter ? renter.email : '',
        monthlyFee: Money.roundNumber(Number(apt.monthlyFee) / 100, 2)
    }), [renderCsv]);

    const renderTenantType = (tenantType, i) => <div className='value' key={i}>{t(`payments.${tenantType}`)}</div>;

    const renderDetailsByType = (type, details, i) => {
        if (type === 'name') return <div className='value name' key={i}>{details.name}</div>
        else if (type === 'phone') return <div className='value' key={i}>{details.phone}</div>
        else return <div className='value email' key={i}>{details.email}</div>
    };

    const renderRenterDetails = (tenants, type) => {
        const mainRenter = tenants?.find(({ tenant }) => tenant.isActive && tenant.isPrimary && tenant.tenantType === constants.APIContract.tenantTypes.renter);
        if (mainRenter) return renderDetailsByType(type, mainRenter.details, Math.random())
        else return <div className='value'></div>
    };

    const renderOwnerDetails = (tenants, type) => {
        const mainOwner = tenants?.find(({ tenant }) => tenant.isActive && tenant.isPrimary && tenant.tenantType === constants.APIContract.tenantTypes.owner);
        if (mainOwner) return renderDetailsByType(type, mainOwner.details, Math.random())
        else return <div className='value'></div>
    };

    return (
        show && (
            <InfoCardStyled selected={selected} onClick={() => onClick(num)} ltr={ltr}>
                <div className='card-title'>
                    <span>{t('payments.number_of_apartment')}: {apt?.apartmentNum}</span>
                    <span className='title-icons-wrapper'>
                        {apt?.withBuildingManager && <img src={manager} />}
                        {apt?.withLegalIssues && <img src={hammer} />}                    
                    </span>
                </div>
                <div className='tenant-card-body'>
                    <div>
                        <div className='inner-title'>{t('reports.ownership_type')}</div>
                        {Object.values(constants.APIContract.tenantTypes).map((tenantType, i) => renderTenantType(tenantType, i))}
                    </div>
    
                    <div>
                        <div className='inner-title'>{t('expenses.name')}</div>
                        {renderRenterDetails(apt?.tenants, 'name')}
                        {renderOwnerDetails(apt?.tenants, 'name')}
                    </div>
    
                    <div>
                        <div className='inner-title'>{t('expenses.phone_number')}</div>
                        {renderRenterDetails(apt?.tenants, 'phone')}
                        {renderOwnerDetails(apt?.tenants, 'phone')}
                    </div>
    
                    <div>
                        <div className='inner-title'>{t('expenses.email')}</div>
                        {renderRenterDetails(apt?.tenants)}
                        {renderOwnerDetails(apt?.tenants)}
                    </div>
                </div>
            </InfoCardStyled>
        )
    )
}

export default TenantCard;